import axios from 'axios';
import { statsFunctionWrapper } from '@fiverr-private/homepage_utils';
import { BuyerProfileCompletionResponseData } from '../../types';
import { logError } from './logger';
import { getBuyerProfileCompletionAPIUrl } from './urls';

export const fetchCompletionPercentage = async (url: string): Promise<number | null> => {
    try {
        const fetcher = () => axios.get<BuyerProfileCompletionResponseData>(getBuyerProfileCompletionAPIUrl(url));
        const { data } = await statsFunctionWrapper(fetcher, 'jtbd.business_info.fetch_completion_percentage')();

        const percentage = data?.data.percentage;

        const resultRoundedToNearest5 = Math.round(percentage / 5) * 5;

        return resultRoundedToNearest5;
    } catch (error) {
        logError({ message: 'Failed to fetch completion percentage', details: { error } });

        return null;
    }
};
